//react
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

//components
import PopupExternalLink from '../popup/externalLink';

//data
import dataSiteMap from '../../siteMap.json';

//assets
import './buttonCulture.css';

class ButtonCulture extends Component {
	constructor() {
		super();

		this.state = {
			popupCulture: 'uk',
			popupUrl: null,
		};

		this.popup = this.popup.bind(this);
		this.openPopup = this.openPopup.bind(this);
		this.closePopup = this.closePopup.bind(this);
	}

	popup() {
		if (this.state.popupUrl) {
			return (
				<PopupExternalLink close={this.closePopup} culture={this.state.popupCulture} url={this.state.popupUrl} />
			);
		}

		return null;
	}

	openPopup(culture, url) {
		this.setState({
			popupCulture: culture,
			popupUrl: url,
		});
	}

	closePopup(event, preventDefault) {
		if (preventDefault) {
			event.preventDefault();
		}

		this.setState({
			popupUrl: null,
		});
	}

	render() {
		if (this.props.external) {
			return (
				<div className="button-culture-wrapper">
					{this.popup()}

					<button className="button-culture hwa" onClick={() => this.openPopup(this.props.cultureCode, this.props.external)} style={this.props.style}>
						<div className="button-culture__label">{this.props.label}</div>
						<div className="button-culture__flag">
							<img alt={this.props.label + ' flag'} className="button-culture__flag__image" src={require('./' + this.props.cultureCode + '.png')} />
						</div>
					</button>
				</div>
			);
		}

		let linkTo = '/' + this.props.cultureCode;

		if (this.props.culture && !this.props.pageNotFound) {
			linkTo = window.location.pathname.replace(this.props.culture, this.props.cultureCode);
		}

		return (
			<Link className="button-culture hwa" hrefLang={dataSiteMap[this.props.cultureCode].cultureCode} style={this.props.style} to={linkTo}>
				<div className="button-culture__label">{this.props.label}</div>
				<div className="button-culture__flag">
					<img alt={this.props.label + ' flag'} className="button-culture__flag__image" src={require('./' + this.props.cultureCode + '.png')} />
				</div>
			</Link>
		);
	}
}

export default ButtonCulture;



// WEBPACK FOOTER //
// ./src/components/buttonCulture/buttonCulture.js